/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the "Elastic License
 * 2.0", the "GNU Affero General Public License v3.0 only", and the "Server Side
 * Public License v 1"; you may not use this file except in compliance with, at
 * your election, the "Elastic License 2.0", the "GNU Affero General Public
 * License v3.0 only", or the "Server Side Public License, v 1".
 */

/**
 * A common type for filters supported by this package
 * @public
 **/

/**
 * An enum of all types of filters supported by this package
 * @public
 */
export let FILTERS = /*#__PURE__*/function (FILTERS) {
  FILTERS["CUSTOM"] = "custom";
  FILTERS["PHRASES"] = "phrases";
  FILTERS["PHRASE"] = "phrase";
  FILTERS["EXISTS"] = "exists";
  FILTERS["MATCH_ALL"] = "match_all";
  FILTERS["QUERY_STRING"] = "query_string";
  FILTERS["RANGE"] = "range";
  FILTERS["RANGE_FROM_VALUE"] = "range_from_value";
  FILTERS["SPATIAL_FILTER"] = "spatial_filter";
  FILTERS["COMBINED"] = "combined";
  return FILTERS;
}({});

/**
  Filter,
 * An enum to denote whether a filter is specific to an application's context or whether it should be applied globally.
 * @public
 */
export let FilterStateStore = /*#__PURE__*/function (FilterStateStore) {
  FilterStateStore["APP_STATE"] = "appState";
  FilterStateStore["GLOBAL_STATE"] = "globalState";
  return FilterStateStore;
}({});

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions

/**
 * An interface for a latitude-longitude pair
 * @public
 */